import { getCookie } from '@picsart/rc/cookie';
import { L as Logger } from '../logger-4df3b60c.js';

/* eslint-disable prefer-destructuring */
var IMPACT_COOKIE_NAME = 'IR_11703';
var IMPACT_ACCOUNT_ID = 21486;
var loadImpactScript = function loadImpactScript() {
  return new Promise(function (resolve, reject) {
    if (window.ire) {
      return resolve();
    }
    try {
      // copied from impact docs
      (function (a, b, c, d, e, f, g) {
        e.ire_o = c;
        e[c] = e[c] || function () {
          (e[c].a = e[c].a || []).push(arguments);
        };
        f = d.createElement(b);
        g = d.getElementsByTagName(b)[0];
        f.async = 1;
        f.src = a;
        g.parentNode.insertBefore(f, g);
      })('//d.impactradius-event.com/A2346528-7c55-4176-bb64-ba0700000dda1.js', 'script', 'ire', document, window);
    } catch (error) {
      Logger.error(error);
    }
    var checkLimit = 10;
    var checkCount = 0;
    var intervalId = setInterval(function () {
      if (window.ire) {
        clearInterval(intervalId);
        return resolve();
      }
      if (checkCount > checkLimit) {
        clearInterval(intervalId);
        return reject();
      }
      checkCount++;
    }, 500);
  });
};
var impactIdentify = function impactIdentify() {
  var customerId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var customerEmail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (window.ire) {
    window.ire('identify', {
      customerId: customerId,
      customerEmail: customerEmail
    });
  }
};
var impactTrackConversion = function impactTrackConversion(orderId, customerId) {
  var customerEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var customerStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'New';
  if (window.ire) {
    window.ire('trackConversion', IMPACT_ACCOUNT_ID, {
      orderId: orderId,
      customerId: customerId,
      customerEmail: customerEmail,
      customerStatus: customerStatus
    }, {
      verifySiteDefinitionMatch: true
    });
  }
};
var getImpactClickId = function getImpactClickId() {
  var impactCookie = getCookie(IMPACT_COOKIE_NAME);
  if (impactCookie) {
    var decodedCookie = decodeURIComponent(impactCookie);
    var impactClickId = decodedCookie.split('|')[3];
    return impactClickId;
  }
  return '';
};
var impactService = {
  impactTrackConversion: impactTrackConversion,
  getImpactClickId: getImpactClickId,
  loadImpactScript: loadImpactScript,
  impactIdentify: impactIdentify
};

export { impactService as default, getImpactClickId, impactIdentify, impactTrackConversion, loadImpactScript };
//# sourceMappingURL=index.js.map
